<template>
  <div class="StoryModal" v-if="obj">
    <div class="c-modal d-none justify-content-center align-items-center" ref="modal" :id="'story-modal-'+obj.id" >
        <div class="position-relative h-100">
            <button aria-label="بستن" type="button" class="btn-close position-absolute t-2 r-2 pointer" @click="closeModal()"></button>
            <div class="n-p l-0 t-2 next-div pointer" @click="next()">
            </div>
            <video class="h-100" playsinline ref="video" :poster="$MEDIA + obj.videoCover" :id="'story-video-'+obj.id" @dragstart.prevent @contextmenu.prevent @mousedown="this.$refs.video.pause()" @mouseup="this.$refs.video.play()"  @touchstart="this.$refs.video.pause()" @touchend="this.$refs.video.play()">
              <source :src="$MEDIA + obj.video" type="video/mp4">
            </video>
            <div class="n-p r-0 t-2 prev-div pointer" @click="prev()">
            </div>
            <button aria-label="دیدن اطلاعات بیشتر" type="button" class="btn btn-dark position-absolute b-2 r-0 w-100 pointer" @click="this.$router.push(link)">بیشتر</button>
        </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'StoryModal',
  props: {
    obj: JSON
  },
  data () {
    return {
      link: null
    }
  },
  methods: {
    closeModal: function () {
      document.getElementById('story-modal-' + this.obj.id).classList.remove('d-flex')
      document.getElementById('story-modal-' + this.obj.id).classList.add('d-none')
      if (!this.$refs.video.paused) {
        this.$refs.video.pause()
      }
    },
    next: function () {
      try {
        if (this.obj.next) {
          document.getElementById('story-modal-' + this.obj.next).classList.add('d-flex')
          document.getElementById('story-modal-' + this.obj.next).classList.remove('d-none')
          document.getElementById('story-video-' + this.obj.next).play()
        }
      } catch {}
      this.closeModal()
    },
    prev: function () {
      try {
        if (this.obj.prev) {
          document.getElementById('story-modal-' + this.obj.prev).classList.add('d-flex')
          document.getElementById('story-modal-' + this.obj.prev).classList.remove('d-none')
          document.getElementById('story-video-' + this.obj.prev).play()
        }
      } catch {}
      this.closeModal()
    }
  },
  mounted () {
    const url = new URL(this.obj.link)
    this.link = url.pathname

    this.$refs.video.addEventListener('play', (event) => {
      const seenList = JSON.parse(localStorage.getItem('seen')) || []

      if (!seenList.includes(this.obj.id)) {
        seenList.push(this.obj.id)
        localStorage.setItem('seen', JSON.stringify(seenList))
        this.emitter.emit('seen')
      }
    })
    this.$refs.video.addEventListener('ended', (event) => {
      this.prev()
    })
  },
  watch: {}
}
</script>
<style scoped>
.h-100{
  height: 100dvh;
}
.c-modal{
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  width: 100%;
  background: #000000b0;
  z-index: 1030;
}
button{
  z-index: 1032;
}
.btn-close{
  box-shadow: white 0px 0px 4px;
  background-color: white;
}
.t-2{
  top:1rem;
}
.r-2{
  right:1rem;
}
.r-0{
  right:0;
}
.l-0{
  left:0;
}
.b-2{
  bottom:1rem;
}
.b-3{
  bottom:5rem;
}
video{
  width: 100%;
  max-height: 880px;
}
.btn{
  color:white;
  background-color:#212529;
  border: none;
  border-radius:5px
}
.n-p{
  height: 80%;
  position: absolute;
  width: 25%;
  z-index: 1031;
}
.play{
  display: none;
  position: absolute;
  bottom: 0;
  top: 0;
  right: 0;
  left: 0;
  z-index: 1031;
  background: #00000047;
  border: none;
  border-radius: 16px;
  height: 100%;
  width: 100%;
}
</style>
